export default function printTable(component) {
  const content = `
    <html>
      <head>
        <style>
          @page {
            margin: 15mm 10mm 20mm 10mm;
            @bottom-center {
              content: "Página " counter(page) " de " counter(pages);
              font-family: 'Roboto', sans-serif;
              font-size: 10px;
              color: #555;
            }
          }

          body {
            font-family: 'Roboto', sans-serif;
            margin: 0;
            padding: 0;
          }

          .print-table {
            border-collapse: collapse;
            font-family: 'Roboto', sans-serif;
            width: 100%;
            margin-bottom: 20px;
            margin-top: 20px;
          }

          .texto{
            font-family: 'Roboto', sans-serif !important;
          }

          .logo{
            display: flex;
            justify-content: center;
            align-items: center;
          }

          .logo img{
            width: 200px;
          }

          .print-header {
            display: flex !important;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 12px;
            padding-bottom: 8px;
            border-bottom: 1px solid #ccc;
          }

          .print-header-logo {
            flex: 1;
          }

          .print-header-logo img {
            height: 3rem;
            max-width: 180px;
            object-fit: contain;
          }

          .print-header-title {
            flex: 2;
            text-align: center;
            font-family: 'Roboto', sans-serif;
            font-size: 14px;
            font-weight: 600;
            margin: 0;
          }

          .print-header-date {
            flex: 1;
            text-align: right;
            font-family: 'Roboto', sans-serif;
            font-size: 11px;
            color: #444;
          }

          .print-table td, .print-table th {
            border: 1px solid #00000077;
            font-size: 11px;
            text-align: left;
            font-weight: 400;
            font-family: 'Roboto', sans-serif;
          }

          .print-table th{
            text-align: center;
            background-color: #222222;
            color: #EEEEEE;
          }

          .print-table .oneline td{
            border: 1px dotted #000000;
          }

          .alinear-izquierda{
            text-align: left !important;
          }

          .alinear-derecha{
            text-align: right !important;
          }

          .alinear-centro{
            text-align: center !important;
          }

          .print-table .noprint{
            display: none;
          }
        </style>
      </head>
      <body>
        ${component?.innerHTML}
      </body>
    </html>
`;

  //Creo iframe con la tabla a imprimir
  const print = window.document.createElement("iframe");
  print.style.display = "none";
  document.body.appendChild(print);

  print.contentDocument.write(content);
  print.contentDocument.close();
  print.contentWindow.focus();
  print.contentWindow.print(); //Imprimo

  //Quito el iframe al terminar
  document.body.removeChild(print);
}
